import { Component, Input } from '@angular/core';
import { Conference } from '@core/models/conference.model';

@Component({
  selector: 'app-single-conference-block',
  templateUrl: './single-conference-block.component.html',
  styleUrl: './single-conference-block.component.css',
})
export class SingleConferenceBlockComponent {
  @Input() conference?: Conference;
}
